import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { XIcon } from 'lucide-react';
export function Gallery() {
  const [selectedImage, setSelectedImage] = useState<string | null>(null);
  const images = ['https://cdn.magicpatterns.com/uploads/qo2or2WKtSF7AeJ4J3iXwQ/Hitube_d5YKiJgLKz_2026_05_13_13_14_29.jpg', 'https://cdn.magicpatterns.com/uploads/kq3CyWFyGw1r4DWctmMjSd/Hitube_FZiKjy9XS8_2026_05_13_13_15_38.jpg', 'https://cdn.magicpatterns.com/uploads/obJPwzuNFg4vCznmqjggLu/Hitube_PR61GOwwe1_2026_05_13_00_57_35.jpg', 'https://images.unsplash.com/photo-1578985545062-69928b1d9587?w=800&q=80', 'https://cdn.magicpatterns.com/uploads/8pdgXNiwMEtZ58K2L1oSYD/Hitube_fSnwfdjQpj_2026_05_13_13_36_45.jpg', 'https://cdn.magicpatterns.com/uploads/w6b5MHXw4Mtdfhw3yBN5Wa/Hitube_G05dJs4iPx_2026_05_13_13_37_26.jpg', 'https://cdn.magicpatterns.com/uploads/tmJ5iPVuTBgMbfmbTYRKiG/Hitube_2vjlphychU_2026_05_13_13_47_15.jpg', 'https://images.unsplash.com/photo-1533777857889-4be7c70b33f7?w=800&q=80'];
  return <section id="galeria" className="py-20 bg-secondary-cream" data-id="element-54">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-55">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-12" data-id="element-56">
          <h2 className="text-4xl md:text-5xl font-serif font-bold text-secondary-brown mb-4" data-id="element-57">
            Galería
          </h2>
          <p className="text-lg text-secondary-brown-light" data-id="element-58">
            Un vistazo a nuestros productos y momentos especiales
          </p>
        </motion.div>

        <div className="grid grid-cols-2 md:grid-cols-4 gap-4" data-id="element-59">
          {images.map((image, index) => <motion.div key={index} initial={{
          opacity: 0,
          scale: 0.9
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.05
        }} whileHover={{
          scale: 1.05
        }} onClick={() => setSelectedImage(image)} className="relative h-64 rounded-xl overflow-hidden cursor-pointer group" data-id="element-60">
              <img src={image} alt={`Galería ${index + 1}`} className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500" data-id="element-61" />
              <div className="absolute inset-0 bg-black/0 group-hover:bg-black/20 transition-colors" data-id="element-62" />
            </motion.div>)}
        </div>
      </div>

      <AnimatePresence data-id="element-63">
        {selectedImage && <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} exit={{
        opacity: 0
      }} onClick={() => setSelectedImage(null)} className="fixed inset-0 bg-black/90 z-50 flex items-center justify-center p-4" data-id="element-64">
            <button onClick={() => setSelectedImage(null)} className="absolute top-4 right-4 text-white hover:text-primary-yellow transition-colors" aria-label="Cerrar" data-id="element-65">
              <XIcon size={32} data-id="element-66" />
            </button>
            <motion.img initial={{
          scale: 0.9
        }} animate={{
          scale: 1
        }} exit={{
          scale: 0.9
        }} src={selectedImage} alt="Vista ampliada" className="max-w-full max-h-full object-contain rounded-lg" data-id="element-67" />
          </motion.div>}
      </AnimatePresence>
    </section>;
}